import { startAuthentication, startRegistration, browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from "@simplewebauthn/browser";
import { api, masterApi } from "@/lib/api";

export const passkeySupported = () => browserSupportsWebAuthn();
export const biometricAvailable = async () => passkeySupported() && (await platformAuthenticatorIsAvailable().catch(() => false));

const DEVICE_KEY = "zb_passkey_device";
const OFFER_KEY = "zb_offer_passkey";
export const hasPasskeyDevice = () => localStorage.getItem(DEVICE_KEY) === "1";
const markDevice = () => localStorage.setItem(DEVICE_KEY, "1");
// Set after a password login/registration so the app offers passkey set-up once.
export const queuePasskeyOffer = () => sessionStorage.setItem(OFFER_KEY, "1");
export const takePasskeyOffer = () => { const v = sessionStorage.getItem(OFFER_KEY) === "1"; sessionStorage.removeItem(OFFER_KEY); return v; };
export const skipKey = (accountId) => `zb_passkey_skip_${accountId}`;

const friendly = (e, fallback) => {
  const msg = e?.name === "NotAllowedError" ? "Cancelled or timed out"
    : e?.name === "InvalidStateError" ? "This device already has a passkey for this account"
    : e?.response?.data?.detail || fallback;
  const err = new Error(msg); err.cancelled = e?.name === "NotAllowedError" || e?.name === "AbortError";
  return err;
};

export const registerPasskey = async (label, staffId) => {
  try {
    const { data } = await api.post("/auth/passkey/registration/options", staffId ? { staff_id: staffId } : {});
    const credential = await startRegistration({ optionsJSON: data.options });
    await api.post("/auth/passkey/registration/verify", { credential, transaction_id: data.transaction_id, label });
    markDevice();
  } catch (e) { throw friendly(e, "Could not add passkey"); }
};

// Usernameless one-touch sign-in; returns { master_token, account, token, user }.
export const signInWithPasskey = async (app = "admin") => {
  try {
    const { data } = await masterApi.post("/auth/passkey/authentication/options");
    const credential = await startAuthentication({ optionsJSON: data.options });
    const { data: out } = await masterApi.post("/auth/passkey/authentication/verify", { credential, transaction_id: data.transaction_id, app });
    markDevice();
    return out;
  } catch (e) { throw friendly(e, "Passkey sign-in failed"); }
};
